import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import gettext from '@sdk/lang/gettext';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import { FooterRegularButtonWrapper } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';

type Props = {
  onSave: () => Promise<void>;
  canSubmit: boolean;
};
const SaveTimesheetFooterButton = ({ onSave, canSubmit }: Props) => {
  return (
    <FooterRegularButtonWrapper mLeft={10}>
      <ProgressButton
        buttonType={canSubmit ? ButtonType.primary : ButtonType.disabledStyle}
        onClick={onSave}
        height={38}>
        {gettext('Save')}
      </ProgressButton>
    </FooterRegularButtonWrapper>
  );
};

export default SaveTimesheetFooterButton;
